<template>
  <div class="home card">
    <div class="text-2xl md:text-xl text-center mt-16 px-4 md:px-0">
      Your vNFTs
    </div>
    <NFTList
      @NFTClick="onNFTClick"
      class="cursor-pointer"
      :leaderboard="false"
    />
  </div>
</template>

<script>
// @ is an alias to /src
import NFTList from "@/components/NFTList.vue";

export default {
  name: "Home",
  components: {
    NFTList,
  },
  created: function () {},
  methods: {
    onNFTClick: function (contract, id) {
      this.$router.push({ name: "vNFT", params: { id: id } });
    },
  },
};
</script>
